/* LUXURIA – deutsche Texte für die Produktoptionen-App (APO)
   Die App liefert einige Beschriftungen auf Englisch aus ihrer eigenen Übersetzungs-Konfiguration
   (i18n_configure_link, i18n_characters_left, i18n_per_character, i18n_modal_submit_btn).
   Dauerhafte Lösung: diese Texte in den APO-Einstellungen auf Deutsch setzen – dann greift dieses Skript nicht mehr.
   Bis dahin werden nur sichtbare Texte ersetzt; Werte, Preise und Logik der App bleiben unberührt. */
(function () {
  'use strict';

  var RULES = [
    { re: /\bEdit Options\b/, to: 'Optionen ändern' },
    { re: /\bCharacters left:\s*/, to: 'Noch verfügbare Zeichen: ' },
    { re: /\bper character\b/, to: 'pro Zeichen' }
  ];
  var TEST = /Edit Options|Characters left|per character|^\s*Submit\s*$/;

  function fixText(node) {
    var v = node.nodeValue;
    if (!v || !TEST.test(v)) return;
    var out = v;
    RULES.forEach(function (r) { out = out.replace(r.re, r.to); });
    // "Submit" nur innerhalb der App-Elemente (Options-Dialog), nie global
    if (/^\s*Submit\s*$/.test(out) && node.parentElement && node.parentElement.closest('[class*="mw-"], [class*="mws-"], [id*="mw-"]')) {
      out = out.replace('Submit', 'Übernehmen');
    }
    if (out !== v) node.nodeValue = out;
  }

  function scan(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixText(root); return; }
    if (root.nodeType !== 1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return TEST.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP; }
    });
    var n;
    while ((n = walker.nextNode())) fixText(n);
  }

  function start() {
    scan(document.body);
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        if (m.type === 'characterData') fixText(m.target);
        else m.addedNodes.forEach(scan);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
